import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Lightbulb: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <g>
      <path
        d="M19.347 37.244h8.449v2.478h-8.449zM19.35 41.024v.205c0 1.587 1.018 2.271 2.263 2.271h3.923c1.245 0 2.263-.684 2.263-2.27v-.206h-8.45zM32.777 21.328c-.65-4.06-4.035-7.266-8.121-7.726a9.66 9.66 0 0 0-1.081-.059c-.357 0-.717.018-1.082.06-4.086.459-7.471 3.664-8.121 7.725-.493 3.082.526 5.94 2.432 7.95 1.53 1.614 2.08 2.055 2.391 4.346l.16 2.317H27.794l.16-2.317c.312-2.29.862-2.732 2.392-4.346 1.906-2.01 2.925-4.868 2.432-7.95z"
        fill="#ff612b"
      />
      <path
        d="M23.575 11.307a1.238 1.238 0 0 1-1.239-1.239V5.805a1.238 1.238 0 1 1 2.477 0v4.263c0 .684-.554 1.239-1.238 1.239zM14.104 15.234c-.27 0-.542-.088-.77-.27L9.998 12.31a1.24 1.24 0 0 1 1.543-1.938l3.334 2.655a1.24 1.24 0 0 1-.772 2.208zM32.687 14.9a1.238 1.238 0 0 1-.772-2.207l3.335-2.655a1.238 1.238 0 1 1 1.542 1.938l-3.335 2.655c-.227.181-.5.27-.77.27z"
        fill="#002677"
      />
      <path
        d="M29.46 23.282a1.238 1.238 0 0 1-1.24-1.239 3.767 3.767 0 0 0-3.762-3.762 1.238 1.238 0 1 1 0-2.477c3.44 0 6.24 2.8 6.24 6.24 0 .683-.555 1.238-1.239 1.238z"
        style={{
          fill: '#fff',
        }}
      />
    </g>
  </Box>
)
export default Lightbulb
